import { ConfigurationValues } from '@cutr/constants/windows/windows';

import { unboxLabel } from '../Configurations';
import { optionFilterBySystem } from '../inputs/ConfigurationSelect';
import { ConfigurationSelect } from '../inputs/ConfigurationSelect';
import { ConfigurationComponent } from '.';

const HandleConfig = () => (
  <ConfigurationSelect
    configurationKey="handle"
    dispatchAction="SET_HANDLE"
    optionsFilterFn={optionFilterBySystem}
  />
);

const config: ConfigurationComponent<'handle'> = {
  key: 'handle',
  input: <HandleConfig />,
  display: (value: ConfigurationValues['handle']) => (
    <span>{unboxLabel(value.label)}</span>
  ),
};

export default config;
